import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BasicConfigService } from '@core/service/basicConfig.service';

@Component({
  selector: 'layout-passport',
  templateUrl: './passport.component.html',
  styleUrls: ['./passport.component.less']
})
export class LayoutPassportComponent implements OnInit {
  leftWidth: string;
  deployTitle: string;
  WorkersData: { [key: string]: any };

  constructor(
    private readonly store: Store<{ layout: { passportWidth: string } }>,
    private readonly configService: BasicConfigService
  ) {
    this.deployTitle = this.configService.get<{ [key: string]: string }>('InfoDeploy').systemName;
    this.WorkersData = this.configService.get<{ [key: string]: any }>('CustonMadeConfig');
  }

  ngOnInit(): void {
    this.store
      .select(state => state.layout && state.layout.passportWidth)
      .subscribe(width => {
        this.leftWidth = width ?? '480px';
      });
  }
}
